import React, { useContext } from 'react';
import { useAlert } from '../ui/alertProvider';
import { Patient } from '../../../Models/Patient';
import patientsContext from '../../store/patientsContext';
import Patients from './patients';
import ApiClient from '../../Services/ApiClient';
import AuthContext from '../../store/authContext';
import PatientDashboard from './PatientDashboard';

const PatientsWrapper = () => {
    const context = useContext(patientsContext) as any;
    const [loading, error, patients, fetchPatients, addPatientToCache, updatePatientInCache, removePatientFromCache] = context;
    const { showAlert } = useAlert();
    const auth = useContext(AuthContext) as any;
    const { isAdmin } = auth ?? { isAdmin: false };

    if (!isAdmin) return <div>אין הרשאה לצפות בדף זה</div>;

    const handleAdd = async (newPatient: Omit<Patient, 'id' | 'creationDate'>): Promise<Patient | null> => {
        try {
            const created: Patient = await ApiClient.post('/patients', newPatient);
            if (created && created.id) {
                // add to local cache so UI updates
                addPatientToCache(created);
                showAlert('מטופל נוסף בהצלחה', 'success');
                return created;
            }
            showAlert('שגיאה בתשובת השרת בעת יצירת מטופל', 'error');
            return null;
        } catch (err: any) {
            const server = err?.data;
            if (server && server.errors) {
                // show each field error as alert
                if (server.errors.firstName) showAlert(server.errors.firstName, 'error');
                if (server.errors.lastName) showAlert(server.errors.lastName, 'error');
                if (server.errors.email) showAlert(server.errors.email, 'error');
                if (server.errors.phone) showAlert(server.errors.phone, 'error');
                return null;
            }
            showAlert(err?.data?.failureReason || err?.message || 'שגיאה ברשת בעת יצירת מטופל', 'error');
            return null;
        }
    };

    // Update uses server call then dispatch updatePatient thunk
    const handleUpdate = async (updatedPatient: Patient) => {
        try {
            await ApiClient.put(`/patients/${updatedPatient.id}`, updatedPatient);
            updatePatientInCache(updatedPatient);
            showAlert('פרטי המטופל עודכנו', 'success');
        } catch (err: any) {
            showAlert(err?.data?.failureReason || err?.message || 'שגיאה בעדכון מטופל', 'error');
        }
    };

    // Optimistic delete
    const handleRemove = async (id: number) => {
        try {
            await ApiClient.delete(`/patients/${id}`);
            removePatientFromCache(id);
            showAlert('מטופל הוסר', 'success');
        } catch (err: any) {
            showAlert(err?.data?.failureReason || err?.message || 'שגיאה במחיקת מטופל', 'error');
        }
    };

    const isPatient = auth?.isPatient || (auth?.roles && auth.roles.includes('Patient'));
    if (isPatient) {
        return <PatientDashboard />;
    }
    return (
        <Patients
            patients={patients}
            onAddPatient={handleAdd}
            onUpdatePatient={handleUpdate}
            onRemovePatient={handleRemove}
        />
    );
};

export default PatientsWrapper;